






import {Component, Vue} from 'vue-property-decorator'
import {MetaInfo} from 'vue-meta'
import DappDetailed from '@/components/dappDetailed/DappDetailed.vue'

@Component({
  components: {DappDetailed},
})
export default class AppDetailedView extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: this.$translate('metadata.title.appDetailed', {
        appName: this.$route.params.id,
      }),
    }
  }
}
